import { motion, useScroll, useTransform } from "framer-motion";
import {
  Container,
  Description,
  ItemsGrid,
  LinkInfo,
  Title,
} from "./WhyPressKitStyles";
import WhyCard from "../whyCard/WhyCard";
import Mic from "../../img/whyPressKit/mic.png";
import Music from "../../img/whyPressKit/music.png";
import Calendar from "../../img/whyPressKit/date.png";
import Social from "../../img/whyPressKit/link.png";
import { fadeUp } from "../../styles/animations";

const data = [
  {
    icon: Mic,
    title: "Biografia:",
    description: "Compartilhe sua história e influências musicais.",
  },
  {
    icon: Music,
    title: "Músicas e Sets:",
    description: "Coloque links de suas músicas ou sets e adicione vídeo.",
  },
  {
    icon: Calendar,
    title: "Eventos:",
    description: "Divulgue datas e locais das suas apresentações.",
  },
  {
    icon: Social,
    title: "Redes Sociais:",
    description:
      "Conecte seu público às suas plataformas, como SoundCloud, Spotify e Instagram.",
  },
];

const WhyPressKit = () => {
  return (
    <Container id="why">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
      >
        <Title>Por que usar o Press Kit?</Title>
      </motion.div>

      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
        custom={1}
      >
        <Description>
          Com o Press Kit, você pode destacar seu trabalho musical em um
          portfólio completo e personalizável, que inclui tudo o que importa
          para promover sua carreira:
        </Description>
      </motion.div>

      <ItemsGrid>
        {data.map((item, index) => (
          <motion.div
            key={index}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.1 }}
            custom={index + 2}
          >
            <WhyCard {...item} />
          </motion.div>
        ))}
      </ItemsGrid>

      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
        custom={6}
      >
        <LinkInfo>
          Crie um <span>link exclusivo</span> para compartilhar com contratantes
          e fãs e leve sua carreira ao próximo nível!
        </LinkInfo>
      </motion.div>
    </Container>
  );
};

export default WhyPressKit;
